(function($) {
    $(() => {
        const slider = $('.blog_slider');

        slider.on('init reInit', function(event, slick) {
            $('.blog_slider__total-count').html(`1/${slick.slideCount}`);
        });

        slider.on('afterChange', function (event, slick, currentSlide) {
            $('.blog_slider__total-count').html(`${currentSlide + 1}/${slick.slideCount}`);
        });

        slider.slick(
            {
                infinite: false,
                slidesToShow: 3,
                arrows: false,
                nextArrow:  $('.blog_slider__right'),
                prevArrow:  $('.blog_slider__left'),
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 1,
                            arrows: true,
                            infinite: true,
                        }
                    }
                ]
                // nextArrow:  $('.testimonial-card__right'),
                // prevArrow:  $('.testimonial-card__left'),
            }
        );

        if ($('.js-archive-blogs').length) {
            const container = $('.isotope').isotope({
                itemSelector: '.element-item',
            });

            const initShow = 9;
            const iso = container.data('isotope');
            let counter = initShow;

            loadMore(initShow);

            $('.filters').on( 'click', 'p', function() {
                container.isotope({
                    filter: $(this).attr('data-filter')
                });
                $('.filters  p').removeClass('active');
                $(this).addClass('active');

                if ($(this).data('filter') === '*') {
                    $('.text-filter').val('');
                }
                loadMore(initShow)
            });

            $('.blog-search-result-wrapper__delete').on('click', function () {
                container.isotope({
                    filter: '*'
                });
                $('.filters > p').removeClass('active');
                $('.filters > p[data-filter="*"]').addClass('active');
                $('.text-filter').val('');
                $('.text-filter-mobile').val('');

                $('.blog-search-result-wrapper').hide();
            });

            if (iso.items.length > initShow) {
                container.after(`
                    <div class="row mt-5">
                        <div class="col-lg-12 text-center">
                            <button class="btn btn-primary" id="load-more">További blogbejegyzések</button>
                        </div>
                    </div>
                `);
            }


            function loadMore(toShow) {
                container.find(".hidden").removeClass("hidden");

                const hiddenElems = iso.filteredItems.slice(toShow, iso.filteredItems.length).map(function(item) {
                    return item.element;
                });

                $(hiddenElems).addClass('hidden');
                container.isotope('layout');

                if (hiddenElems.length === 0) {
                    $("#load-more").hide();
                } else {
                    $("#load-more").show();
                }

            }

            $("#load-more").click(function() {
                if ($('.filters').data('clicked')) {
                    counter = initShow;
                    $('.filters').data('clicked', false);
                }

                counter = counter + initShow;

                loadMore(counter);
            });

            let qsRegex;

            // var $quicksearch = $('.text-filter').keyup( debounce( function() {
            //     qsRegex = new RegExp( $quicksearch.val(), 'gi' );
            //     container.isotope({
            //         filter: function() {
            //             return qsRegex ? $(this).text().match( qsRegex ) : true;
            //         }
            //     });
            //     loadMore(initShow)
            // }, 200 ) );

            $('.blog-search-btn').on('click', function () {
                qsRegex = new RegExp($('.text-filter').val(), 'gi' );
                container.isotope({
                    filter: function() {
                        return qsRegex ? $(this).text().match( qsRegex ) : true;
                    }
                });
                $('.blog-search-result-wrapper__term').html($('.text-filter').val());
                $('.blog-search-result-wrapper__count').html(iso.filteredItems.length);
                loadMore(initShow);
                $('.blog-search-result-wrapper').show();
            });

            $('.blog-search-btn-mobile').on('click', function () {
                qsRegex = new RegExp($('.text-filter-mobile').val(), 'gi' );
                container.isotope({
                    filter: function() {
                        return qsRegex ? $(this).text().match( qsRegex ) : true;
                    }
                });
                $('.blog-search-result-wrapper__term').html($('.text-filter').val());
                $('.blog-search-result-wrapper__count').html(iso.filteredItems.length);
                loadMore(initShow);
                $('.blog-search-result-wrapper').show();
            });

            function debounce( fn, threshold ) {
                let timeout;
                threshold = threshold || 100;
                return function debounced() {
                    clearTimeout( timeout );
                    var args = arguments;
                    var _this = this;
                    function delayed() {
                        fn.apply( _this, args );
                    }
                    timeout = setTimeout( delayed, threshold );
                };
            }
        }

        const gallerySlider = $('.gallery-slider');

        gallerySlider.on('init reInit', function(event, slick) {
            $('.gallery-slider__count').html(`1/${slick.slideCount}`);
        });

        gallerySlider.on('afterChange', function (event, slick, currentSlide) {
            $('.gallery-slider__count').html(`${currentSlide + 1}/${slick.slideCount}`);
        });

        gallerySlider.slick(
            {
                infinite: true,
                slidesToShow: 4,
                arrows: true,
                nextArrow:  $('.gallery-slider__right'),
                prevArrow:  $('.gallery-slider__left'),
                centerMode: false,
                responsive: [
                    {
                        breakpoint: 997,
                        settings: {
                            slidesToShow: 1,
                            centerMode: true,
                            centerPadding: '25px'
                        }
                    }
                ]
            }
        ).magnificPopup({
            type: 'image',
            delegate: 'a:not(.slick-cloned)',
            closeOnContentClick: false,
            tLoading: '',
            mainClass: 'mfp-zoom-in mfp-img-mobile',
            image: {
                verticalFit: true,
                tError: ''
            },
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                tCounter: '',
                preload: [0,1],
                arrowMarkup: `<img class="magnific-arrow magnific-arrow-%dir%" src="${ajax.themeurl}/assets/img/nyil.svg" />`, // markup of an arrow button
            },
            zoom: {
                enabled: true,
                duration: 300
            },
            removalDelay: 300,
            callbacks: {

                imageLoadComplete: function() {
                    var self = this;
                    setTimeout(function() { self.wrap.addClass('mfp-image-loaded'); }, 16);
                },

            }
        });

        if ($('#blog_read_time').length && $('#blog_read_time').html() == "") {
            let time = $('#readTime').val();
            if(time == 0) {
                time = parseInt(time, 10) + 1;
                console.log(time);
            }
            console.log(time);
            $('#blog_read_time').html(time + 'p');
        }
    });
})(jQuery);